import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class PlaguedForest4PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.PLAGUED_FOREST4;
}

export default PlaguedForest4PoiTileEntity;
